import jsonwebtoken from 'jsonwebtoken';
import axios from 'axios';
import moment from 'moment';
const AuthModule = {
    namespaced: true,
    state: {
        accessToken: '',
        refreshToken: '',
        user: undefined,
        expire: undefined
    },
    getters: {
        isAuth: (state) => state.accessToken && moment().utc().isBefore(state.expire)
    },
    mutations: {
        setTokens(state, tokens) {
            const { accessToken, refreshToken, user } = tokens;
            state.accessToken = accessToken;
            state.refreshToken = refreshToken;
            state.user = user;
            const { exp } = jsonwebtoken.decode(state.accessToken);
            state.expire = exp * 1000;
        },
        clear(state) {
            state.accessToken = '';
            state.refreshToken = '';
            state.user = undefined;
            state.expire = undefined;
        }
    },
    actions: {
        async signInByGoogleToken({ commit }, token) {
            const { data } = await axios.post('/auth/google', { token });
            commit('setTokens', data);
        } /*
        async reloadToken() {
          const { commit } = this.context
          const { data } = await axios.post('/auth/refreshtoken', { refreshToken: this.refreshToken })
          commit('setTokens', data)
        }*/
    }
};
export default AuthModule;
